export default {"src":"/_next/static/media/usdc.d5dcb030.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};